import { render } from "./SellButton.vue?vue&type=template&id=1b97547a&scoped=true&ts=true"
import script from "./SellButton.vue?vue&type=script&lang=ts"
export * from "./SellButton.vue?vue&type=script&lang=ts"

import "./SellButton.vue?vue&type=style&index=0&id=1b97547a&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b97547a"]])

export default __exports__